import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const ADMIN_WHATSAPP = '56993443682';

const WaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export default function ProfesionalSuccessModal({ onClose, isGuest = false, guestEmail = '', verificationCode = '', title = '', phone = '' }) {
  const navigate = useNavigate();

  const handleWhatsAppVerify = () => {
    const msg = encodeURIComponent(
      `Hola, quiero activar mi ficha de profesional.\nCódigo: ${verificationCode}\nServicio: ${title}\nTeléfono: ${phone}`
    );
    window.open(`https://wa.me/${ADMIN_WHATSAPP}?text=${msg}`, '_blank');
  };

  if (isGuest) {
    return (
      <div className="fixed inset-0 z-[300] flex items-center justify-center p-4"
        role="dialog" aria-modal="true" aria-label="Ficha pendiente de verificación">
        <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
        <div className="relative bg-card rounded-xl shadow-xl w-full max-w-sm p-6 md:p-8 text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-white"
            style={{ background: '#25D366' }}>
            <WaIcon />
          </div>
          <h2 className="font-heading font-bold text-xl text-foreground mb-2">
            ¡Falta un paso!
          </h2>
          <p className="text-sm font-body text-muted-foreground mb-4">
            Tu ficha está <strong className="text-foreground">pendiente de activación</strong>. Contáctanos por WhatsApp para que aparezca en Koronel.
          </p>
          <button
            onClick={handleWhatsAppVerify}
            className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-md font-semibold text-white text-sm mb-4 transition-opacity hover:opacity-90"
            style={{ background: '#25D366' }}
          >
            <WaIcon />
            Activar por WhatsApp
          </button>
          {verificationCode && (
            <div className="flex items-center justify-center gap-2 p-2 rounded-md mb-4"
              style={{ background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)' }}>
              <span className="text-xs font-caption text-muted-foreground">Código:</span>
              <span className="font-mono font-bold text-sm text-foreground tracking-widest">{verificationCode}</span>
            </div>
          )}
          <p className="text-xs font-caption text-muted-foreground mb-5">
            También enviamos un correo a <strong className="text-foreground">{guestEmail}</strong>.
          </p>
          <Button variant="ghost" size="sm" onClick={onClose}>
            Volver al inicio
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4"
      role="dialog" aria-modal="true" aria-label="Ficha publicada">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="relative bg-card rounded-xl shadow-xl w-full max-w-sm p-6 md:p-8 text-center animate-fade-in-up">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
          style={{ background: 'var(--color-primary)' }}>
          <Icon name="User" size={32} color="white" />
        </div>
        <h2 className="font-heading font-bold text-xl text-foreground mb-2">
          ¡Ya estás en Koronel!
        </h2>
        <p className="text-sm font-body text-muted-foreground mb-6">
          Tu ficha está publicada. Los vecinos de la zona ya pueden encontrarte y contactarte.
        </p>
        <div className="flex flex-col gap-3">
          <Button variant="default" fullWidth iconName="Wrench" iconPosition="left" iconSize={16}
            onClick={() => navigate('/profesionales')}>
            Ver directorio de profesionales
          </Button>
          <Button variant="outline" fullWidth iconName="LayoutDashboard" iconPosition="left" iconSize={16}
            onClick={() => navigate('/user-account-dashboard')}>
            Mi cuenta
          </Button>
          <Button variant="ghost" size="sm" onClick={onClose}>
            Publicar otra ficha
          </Button>
        </div>
      </div>
    </div>
  );
}
